<template>
  <!-- :style="{ height: height, width: width }" -->
  <div :class="className" :style="{ width: '100%', height: '100%' }" />
</template>

<script>
import "echarts-liquidfill";
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";

const animationDuration = 6000;

export default {
  mixins: [resize],
  props: {
    itemData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    className: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "100%"
    },
    color: {
      type: String,
      default: "#0AD1FC"
    },
    color2: {
      type: String,
      default: "rgba(16, 161, 221, 0)"
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    if (this.itemData && this.itemData.viewId) {
      this.getChartData(this.itemData.viewId);
    } else {
      this.$nextTick(() => {
        this.initChart();
      });
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    async getChartData(viewId) {
      const { data } = await this.$api.getChartData({
        id: viewId
      });
      const { legend, seriesDataList, xAxisData } = data;
      this.initChart(seriesDataList);
    },
    initChart(seriesDataList = null) {
      this.chart = echarts.init(this.$el, "macarons");

      let value = 0.45;
      let option = {
        // backgroundColor: "#0F224C",
        // title: [
        //   {
        //     text: "本年收缴率",
        //     x: "22%",
        //     y: "70%",
        //     textStyle: {
        //       fontSize: 14,
        //       fontWeight: "100",
        //       color: "#5dc3ea",
        //       lineHeight: 16,
        //       textAlign: "center"
        //     }
        //   }
        // ],
        series: [
          {
            type: "liquidFill",
            radius: "80%",
            center: ["50%", "45%"],
            color: [
              {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#10A1DD"
                  },
                  {
                    offset: 1,
                    color: "#2ca3e2"
                  }
                ],
                globalCoord: false
              }
            ],
            data: seriesDataList ? [seriesDataList[0].dataList, seriesDataList[0].dataList] : [value, value], // data个数代表波浪数
            backgroundStyle: {
              borderWidth: 1,
              color: "RGBA(51, 66, 127, 0.7)"
            },
            label: {
              normal: {
                textStyle: {
                  fontSize: 20,
                  color: "#fff"
                }
              }
            },
            outline: {
              // show: false
              borderDistance: 0,
              itemStyle: {
                borderWidth: 2,
                borderColor: "#112165"
              }
            }
          }
        ]
      };

      this.chart.setOption(option);
    }
  }
};
</script>
